import { z } from 'zod'

export type DataPointToCreate = {
  dataset_id: number
  time: ISODateTime
  value: number | null
}

export const EditTimeseriesResponseSchema = z.object({
  /** Points written to the store. Once a value is expanded across an interval this exceeds the
   * number of cells edited — four stored points per hour on a quarter-hourly series — so it is not
   * what the user should be shown. */
  nr_of_data_points: z.number(),
  /** Cells the user actually edited. Optional: a backend without interval expansion does not send
   * it, and there the two counts are identical anyway. */
  nr_of_edited_values: z.number().optional(),
  queued_job_id: z.number().nullable().optional(),
})
export type EditTimeseriesResponse = z.infer<typeof EditTimeseriesResponseSchema>

export type EditTimeseriesVariables = {
  dataPoints: DataPointToCreate[]
  /**
   * The interval one row of the caller's grid covers, as an ISO-8601 duration. Only the caller knows
   * what its rows mean, so it states it; the endpoint then writes the value across every point
   * inside that interval, making the aggregate a row displays equal what was typed.
   */
  aggregateDuration: string
}

/**
 * A 2xx means the points were written. `unreadable` covers a body that did not match the contract
 * and carries no count: how many landed and whether a job was queued are unknown, which is not the
 * same as the write having failed and must not be reported to the user as one. The number requested
 * is not the number stored — a 2xx can cover zero or partial changes.
 */
export type EditTimeseriesResult = ({ status: 'read' } & EditTimeseriesResponse) | { status: 'unreadable' }
